
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[shop]/categories-sitemap",
      function () {
        return require("private-next-pages/[shop]/categories-sitemap.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[shop]/categories-sitemap"])
      });
    }
  